<thema-core-snack></thema-core-snack>
<router-outlet></router-outlet>
